/* ==================================================================
   Collect Preloved — Redesign behaviour
   ------------------------------------------------------------------
   Intentionally tiny: two behaviours that cannot be done in CSS, no
   library, no framework, no polling. Everything is feature-detected
   and wrapped so a failure can never block the page.

     1. --header-height  -> lets the sticky buy column and the sticky
        facets bar clear the sticky header without hardcoding a number.
     2. Recent searches  -> fills the "Senest søgt" chips in the search
        panel from this visitor's own localStorage. Per-browser only;
        nothing is sent anywhere.
   ================================================================== */
(function () {
  'use strict';

  /* ---- 1. Header height custom property --------------------------- */
  var header = document.getElementById('header');

  function setHeaderHeight() {
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
  }

  setHeaderHeight();
  window.addEventListener('load', setHeaderHeight);

  if (header && 'ResizeObserver' in window) {
    try {
      new ResizeObserver(setHeaderHeight).observe(header);
    } catch (e) {
      /* no-op */
    }
  } else {
    window.addEventListener('resize', setHeaderHeight, { passive: true });
  }

  /* ---- 2. Recent searches ----------------------------------------- */
  var KEY = 'cp_recent_searches';
  var MAX = 5;

  function readRecent() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list)
        ? list.filter(function (t) {
            return typeof t === 'string' && t.trim().length > 1;
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  function writeRecent(term) {
    try {
      var t = String(term || '').trim();
      if (t.length < 2) return;
      var list = readRecent().filter(function (x) {
        return x.toLowerCase() !== t.toLowerCase();
      });
      list.unshift(t);
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* storage unavailable (private mode, blocked cookies) - ignore */
    }
  }

  function searchUrl(term) {
    var base =
      window.theme && window.theme.routes && window.theme.routes.search_url
        ? window.theme.routes.search_url
        : '/search';
    return base + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }

  function renderRecent() {
    var wrap = document.querySelector('[data-cp-recent]');
    var list = wrap && wrap.querySelector('[data-cp-recent-list]');
    if (!wrap || !list) return;

    var terms = readRecent();
    if (!terms.length) {
      wrap.hidden = true;
      return;
    }

    list.textContent = '';
    terms.forEach(function (term) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = searchUrl(term);
      a.textContent = term;
      li.appendChild(a);
      list.appendChild(li);
    });
    wrap.hidden = false;
  }

  /* Capture the term when any search form is submitted. Bound on the
     document so it also covers the drawer form, which the theme renders
     after this script runs. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('form.searchform, form[action*="/search"]')) return;
      var input = form.querySelector('input[name="q"]');
      if (input) writeRecent(input.value);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecent);
  } else {
    renderRecent();
  }

  /* The search drawer is opened by the theme's own side-panel code; the
     chips are already in the DOM, so re-render on open to pick up a term
     stored earlier in the same session. */
  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (t.closest('[href="#Search-Drawer"], .header-search, [data-panel="Search-Drawer"]')) {
        window.setTimeout(renderRecent, 60);
      }
    },
    true
  );
})();
